module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/february/mainvisual-present@2x_7e47edbeeab70f9a14958abf0481ddaa.png";